
      <div class="grid" *ngIf="carInformacionInicial">
        <div class="col-12 md:col-12 lg:col-12 text-center">
          <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
          <span>{{'LBL_CONSULTANDO' | translate }}</span>
        </div>
      </div>
      <div *ngIf="!carInformacionInicial">
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-panel header="{{ 'AGENDA.LBL_INFOESTRUCTURA' | translate}}">
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_CODIGO' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.codigo}}</strong></label>
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_NOMBRE' | translate }}:</label>
                <label class="lg:col-3 col-6 md:col-8 "><strong>{{estFisica.estructuraFisica}}</strong></label>
              </div>
              <div class="grid">
                <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'ESTRUCTURAFISICA.LBL_DIRECCION' | translate }}:</label>
                <label class="lg:col-9 col-6 md:col-8"><strong>{{localizacion ? localizacion.direccion : ''}}</strong></label>
              </div>
            </p-panel>
          </div>
        </div>
        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <div class="grid">
              <label class="lg:col-3 col-6 md:col-4 control-label">{{ 'AGENDA.LBL_ZONA' | translate }}:</label>
              <label class="lg:col-3 col-6 md:col-8 "><strong>{{zona.nombre}}</strong></label>
              <label *ngIf="zona.nombreEjecutivo" class="lg:col-3 col-6 md:col-4 control-label">{{ 'AGENDA.LBL_EJECUTIVO' | translate }}
                :</label>
              <label *ngIf="zona.nombreEjecutivo" class="lg:col-3 col-6 md:col-8 "><strong>{{zona.nombreEjecutivo}}</strong></label>
            </div>
          </div>
        </div>

        <div class="grid">
          <div class="col-12 md:col-12 lg:col-12">
            <p-tabView>
              <p-tabPanel *ngFor="let dia of dias; let i = index;let first = first;" header="{{ dia.encabezado | translate}}"
                          [selected]="tabSeleccionado === dia.codigo">
                <div class="grid">
                  <div class="col-12 md:col-12 lg:col-12">
                    <div class="grid">
                      <div class="col-12 md:col-12 lg:col-12">
                        <p-table [columns]="columnas" [loading]="dia.cargando"
                                 [value]="dia.datos"
                                 [paginator]="true" [rows]="10"  paginatorPosition="bottom">
                          <ng-template pTemplate="header" let-columns>
                            <tr>
                              <th *ngFor="let col of columns" [pSortableColumn]="col.field"
                                  [pSortableColumnDisabled]="!col.sort"
                                  class="text-center">
                                {{col.header}}
                                <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                              </th>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="body" let-row>
                            <tr [pSelectableRow]="row">
                              <td>{{row.barrio}}</td>
                              <td>{{row.fragmento ? row.fragmento : ('LBL_NA' | translate)}}</td>
                            </tr>
                          </ng-template>
                          <ng-template pTemplate="emptymessage" let-columns>
                            <tr>
                              <td [attr.colspan]="columns.length" class="text-center">
                                {{ 'MSG_NOHAYREGISTROS' | translate}}
                              </td>
                            </tr>
                          </ng-template>
                        </p-table>
                      </div>
                    </div>
                  </div>
                </div>
              </p-tabPanel>
            </p-tabView>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12">
            <button icon="fa fa-arrow-left" label="{{ 'BTN_REGRESAR' | translate }}" type="button"
                    pButton (click)="regresar()"></button>
          </div>
        </div>

      </div>

